<template>
    <div>
        <div v-if="shippingModuleIsInstalled('table_rate')">
            <h4 class="group__headline">Table Rate</h4>
            <div v-if="model.table_rate">
                <el-form-item label="Enabled">
                    <el-radio v-model="model.table_rate.enabled" label="1"
                        >Yes</el-radio
                    >
                    <el-radio v-model="model.table_rate.enabled" label="0"
                        >No</el-radio
                    >
                </el-form-item>
            </div>
            <el-collapse v-model="activeRateGroup" accordion>
                <el-collapse-item
                    :key="rateIndex"
                    :title="rateGroup.name"
                    :name="rateIndex"
                    v-for="(rateGroup, rateIndex) in tablerates"
                >
                    <div v-if="activeRateGroup == rateIndex">
                        <el-form-item label="Name">
                            <el-input v-model="rateGroup.name"></el-input>
                        </el-form-item>

                        <el-form-item label="Country">
                            <select v-model="rateGroup.country" class="select">
                                <option
                                    :key="country.id"
                                    :value="country.id"
                                    v-for="country in countries"
                                >
                                    {{ country.name }}
                                </option>
                            </select>
                        </el-form-item>

                        <el-form-item label="Maximum weight">
                            <el-input v-model="rateGroup.max_weight"></el-input>
                        </el-form-item>

                        <el-form-item label="Time">
                            <el-input v-model="rateGroup.time"></el-input>
                        </el-form-item>

                        <el-form-item label="Postcode start">
                            <el-input v-model="rateGroup.cep_start"></el-input>
                        </el-form-item>

                        <el-form-item label="Postcode end">
                            <el-input v-model="rateGroup.cep_end"></el-input>
                        </el-form-item>

                        <el-form-item
                            v-for="(rate, index) in rateGroup.rates"
                            label="Rate"
                            :key="index"
                        >
                            <el-row :gutter="5">
                                <el-col :span="5">
                                    <el-input
                                        placeholder="From"
                                        v-model="rate.from"
                                    >
                                        <template slot="prepend">Gram</template>
                                    </el-input>
                                </el-col>
                                <el-col :span="5">
                                    <el-input
                                        placeholder="Rate"
                                        v-model="rate.rate"
                                    >
                                        <template slot="prepend"
                                            >Price $</template
                                        >
                                    </el-input>
                                </el-col>
                                <el-col :span="11">
                                    <el-button
                                        @click.prevent="
                                            removeRate(rateIndex, rate)
                                        "
                                        >Delete</el-button
                                    >
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="addRate(rateIndex)"
                                >New rate</el-button
                            >
                        </el-form-item>

                        <el-form-item>
                            <el-button
                                @click="removeRateGroup(rateIndex)"
                                type="danger"
                                >Remove rate group</el-button
                            >
                        </el-form-item>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <div class="u__margin-top">
                <el-button @click="addRateGroup">Add new rate group</el-button>
                <el-button type="primary" @click="saveTableRate"
                    >Save Table Rate</el-button
                >
            </div>
        </div>
        <div v-if="shippingModuleIsInstalled('flatrate')">
            <h4 class="group__headline mt-20">Flat Rate</h4>
            <div v-if="model.flatrate">
                <el-form-item label="Enabled">
                    <el-radio v-model="model.flatrate.enabled" label="1"
                        >Yes</el-radio
                    >
                    <el-radio v-model="model.flatrate.enabled" label="0"
                        >No</el-radio
                    >
                </el-form-item>
            </div>
            <div class="u__margin-top">
                <el-button type="primary" @click="saveFlatRate"
                    >Save Flat Rate</el-button
                >
            </div>
        </div>
        <div v-if="shippingModuleIsInstalled('fedex')">
            <h4 class="group__headline mt-20">Fedex</h4>
            <div v-if="model.fedex">
                <el-form-item label="Enabled">
                    <el-radio v-model="model.fedex.enabled" label="1"
                        >Yes</el-radio
                    >
                    <el-radio v-model="model.fedex.enabled" label="0"
                        >No</el-radio
                    >
                </el-form-item>
            </div>
            <div class="u__margin-top">
                <el-button type="primary" @click="saveFedex"
                    >Save Fedex</el-button
                >
            </div>
        </div>
        <h4 class="group__headline mt-20">Shipping Discounts</h4>
        <el-collapse v-model="activeDiscount" accordion>
            <el-collapse-item
                :key="ruleIndex"
                :title="rule.name"
                :name="ruleIndex"
                v-for="(rule, ruleIndex) in shiprules"
            >
                <div v-if="activeDiscount == ruleIndex">
                    <el-form-item label="Name">
                        <el-input v-model="rule.name"></el-input>
                    </el-form-item>

                    <el-form-item label="Discountend shipping value">
                        <el-input v-model="rule.discounted_shipping"></el-input>
                    </el-form-item>

                    <el-form-item label="Minimum order value">
                        <el-input v-model="rule.free_shipping"></el-input>
                    </el-form-item>

                    <el-form-item label="Maximum order value (Optional)">
                        <el-input v-model="rule.free_shipping_max"></el-input>
                    </el-form-item>

                    <el-form-item label="Delivery type">
                        <el-input v-model="rule.ratekey"></el-input>
                    </el-form-item>

                    <el-form-item
                        v-for="(loc, index) in rule.location"
                        label="Location"
                        :key="index"
                        :rules="{
                            required: true,
                            message: 'location can not be null',
                            trigger: 'blur',
                        }"
                    >
                        <el-col :span="11">
                            <div class="relative">
                                <label
                                    class="inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
                                    >Country</label
                                >
                                <select
                                    v-model="loc.country"
                                    @change="getZonesOnSelectChange($event)"
                                    class="select"
                                >
                                    <option
                                        :key="country.id"
                                        :value="country.id.toString()"
                                        v-for="country in countries"
                                    >
                                        {{ country.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="relative mt-4" v-if="loc.country">
                                <label
                                    class="inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
                                    >State</label
                                >
                                <select
                                    v-model="loc.zone"
                                    class="select"
                                    :disabled="isFetchingZones"
                                >
                                    <option
                                        :key="zone.id"
                                        :value="zone.id.toString()"
                                        v-for="zone in mappedZones[loc.country]"
                                    >
                                        {{ zone.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="relative mt-4">
                                <label
                                    class="inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
                                    >City</label
                                >
                                <el-input v-model="loc.city"></el-input>
                            </div>
                            <div class="relative mt-4">
                                <label
                                    class="inline-block text-xs text-neutral-300 bg-white ml-px absolute top-0 left-2.5 z-10 px-1 transform -translate-y-1/2"
                                    >District</label
                                >
                                <el-input v-model="loc.bairro"></el-input>
                            </div>
                        </el-col>
                        <el-col :span="11" class="flex justify-end">
                            <el-button
                                @click.prevent="removeLocation(ruleIndex, index)"
                                >Delete location</el-button
                            >
                        </el-col>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="addLocation(ruleIndex)"
                            >Add new location</el-button
                        >
                    </el-form-item>

                    <el-form-item class="mt-4">
                        <el-button
                            @click="removeShipDiscount(ruleIndex)"
                            type="danger"
                            >Remove discount</el-button
                        >
                    </el-form-item>
                </div>
            </el-collapse-item>
        </el-collapse>
        <div class="u__margin-top">
            <el-button @click="addDiscount">New discount</el-button>
            <el-button type="primary" @click="saveDiscounts"
                >Save discounts</el-button
            >
        </div>
        <div v-if="model.shipping_discounts && model.shipping_discounts.property">
            <h4 class="group__headline mt-20">Property related free shipping (Free shipping only if all order items have this property set)</h4>
            <el-form-item label="Property name">
                <el-input v-model="model.shipping_discounts.property"></el-input>
            </el-form-item>
            <div class="u__margin-top">
                <el-button type="primary" @click="savePropertyRelatedFreeShipping"
                    >Save Property related free shipping</el-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import api from '../libs/api';

export default {
    props: ['model', 'settings', 'api', 'rootConfig'],

    data() {
        return {
            activeRateGroup: '-1',
            activeDiscount: '-1',
            shiprules: [],
            tablerates: [],
            countries: [],
            zones: [],
            fetchedZones: [],
            isFetchingZones: false,
        };
    },

    created() {
        this.loadCountries();
        this.setShipRules();
        this.setTableRates();
    },

    watch: {
        settings() {
            this.loadCountries();
            this.setShipRules();
            this.setTableRates();
        },
    },
    computed: {
        mappedZones() {
            if (!this.zones.length) {
                return {};
            }

            const mappedZones = {};

            this.zones.forEach((zone) => {
                if (mappedZones.hasOwnProperty(zone.country_id)) {
                    mappedZones[zone.country_id].push(zone);
                } else {
                    mappedZones[zone.country_id] = [];
                    mappedZones[zone.country_id].push(zone);
                }
            });
            return mappedZones;
        },
    },
    methods: {
        loadCountries() {
            let countries = this.$resource(
                this.rootConfig.endPoint + '/countries/{id}',
                {},
                {},
                { headers: this.rootConfig.headers }
            );

            countries
                .get()
                .then((res) => {
                    this.countries = res.data;
                })
                .catch(api.errorHandler);
        },
        initZones() {
            (async () => {
                for (const shipRule of this.shiprules) {
                    for (const loc of shipRule.location) {
                        await this.fetchZones(loc.country);
                    }
                }
            })();
        },
        async getZonesOnSelectChange(event) {
            this.isFetchingZones = true;
            try {
                await this.fetchZones(event.target.value);
            } finally {
                this.isFetchingZones = false;
            }
        },
        getZonesOnSelectChange(event) {
            this.fetchZones(event.target.value);
        },
        async fetchZones(country_id) {
            if (!this.fetchedZones.includes(country_id)) {
                this.isFetchingZones = true;
                let zones = this.$resource(
                    this.rootConfig.endPoint +
                    `/country_zones?country_id=${country_id}`,
                    {},
                    {},
                    { headers: this.rootConfig.headers }
                );

                try {
                    const res = await zones.get();
                    this.fetchedZones.push(country_id);
                    this.zones = [...this.zones, ...res.data];
                } catch (error) {
                    api.errorHandler(error);
                } finally {
                    this.isFetchingZones = false;
                }
            }
        },
        setTableRates() {
            let settings = this.settings.filter((item) => {
                return (
                    item.code === 'table_rate' && item.setting_key === 'rates'
                );
            });

            if (settings.length) {
                this.tablerates = JSON.parse(settings[0].setting);
            } else {
                this.tablerates = [];
            }
        },
        setShipRules() {
            let settings = this.settings.filter((item) => {
                return item.code === 'shiprules';
            });

            if (settings.length) {
                this.shiprules = JSON.parse(settings[0].setting);
            } else {
                this.shiprules = [];
            }

            this.initZones();
        },
        removeLocation(ruleIndex, index) {
          this.shiprules[ruleIndex].location.splice(index, 1);
        },
        removeShipDiscount(index) {
            this.shiprules.splice(index, 1);
        },
        addLocation(ruleIndex) {
            this.shiprules[ruleIndex].location.push({
                country: '',
                zone: '',
                city: '',
                bairro: '',
            });
        },
        addRateGroup() {
            this.tablerates.unshift({
                name: 'Shipping method name',
                country: '',
                max_weight: '',
                time: '',
                method: 'weight',
                rates: [{ from: '0', rate: '0' }],
            });
        },
        removeRateGroup(index) {
            this.tablerates.splice(index, 1);
        },
        removeRate(rateIndex, item) {
            var index = this.tablerates[rateIndex].rates.indexOf(item);
            if (index !== -1) {
                this.tablerates[rateIndex].rates.splice(index, 1);
            }
        },
        addRate(rateIndex) {
            this.tablerates[rateIndex].rates.push({
                from: '0',
                rate: '0',
            });
        },
        addDiscount() {
            this.shiprules.unshift({
                name: 'Rulename',
                discounted_shipping: '0',
                free_shipping: '0',
                location: [],
            });
        },
        save(data) {
            this.api.update({ id: 'mine' }, data).then((res) => {
                this.$emit('updated', res.data);
                this.$message('Updated successfully');
            });
        },
        saveTableRate() {
            let data = {
                shipping_modules: { table_rate: '0' },
                table_rate: {
                    enabled: this.model.table_rate.enabled,
                    rates: JSON.stringify(this.tablerates),
                },
            };
            this.save(data);
        },
        saveFlatRate() {
            let data = {
                shipping_modules: { flatrate: '0' },
                flatrate: {
                    enabled: this.model.flatrate.enabled,
                },
            };
            this.save(data);
        },
        saveFedex() {
            let data = {
                shipping_modules: { fedex: '0' },
                fedex: {
                    enabled: this.model.fedex.enabled,
                },
            };
            this.save(data);
        },
        saveDiscounts() {
            let data = {
                shiprules: { rates: JSON.stringify(this.shiprules) },
            };
            this.save(data);
        },
        shippingModuleIsInstalled(shippingModule) {
            if (
                this.model.shipping_modules &&
                Object.keys(this.model.shipping_modules).includes(
                    shippingModule
                )
            ) {
                return true;
            }
            return false;
        },
        savePropertyRelatedFreeShipping() {
            let data = {
                shipping_discounts: { property: this.model.shipping_discounts.property },
            };
            this.save(data);
        },
    },
};
</script>

<style scoped>
.select {
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTYiIHZpZXdCb3g9I…9uIGZpbGw9IiM2NjYiIHBvaW50cz0iMTIgMTMgOSA4IDE1IDgiPjwvcG9seWdvbj48L3N2Zz4=);
    background-repeat: no-repeat;
    background-position: 100% 50%;
    border: 1px solid #ddd;
    background-color: #fff;
    padding: 0 55px 0 15px;
    box-sizing: border-box;
    margin: 0;
    width: 100%;
    border-radius: 5px;
    font: inherit;
    color: #000;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
}
</style>



// WEBPACK FOOTER //
// Shipping.vue?d243f586